import { Component, OnInit } from '@angular/core';
import { WorkOrder } from 'app/models2/maintenance/work-order';
import { CommentService } from 'app/services/comment.service';

@Component({
  selector: 'app-attached-information',
  templateUrl: './attached-information.component.html',
  styleUrls: ['./attached-information.component.scss']
})
export class AttachedInformationComponent implements OnInit {

  constructor( private commentService: CommentService) { }

  ngOnInit(): void {
  }

  addComment(workOrder: WorkOrder){
    this.commentService.addComment(workOrder[0].id)
  }


}
